import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Button } from "react-bootstrap";

import CategorySelect from "./CategorySelect";
import ModalWrapper from "./ModalWrapper";

export default class CategoryDeleteModal extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = { replacementCategoryId: null };
		this.handleCategoryChange = this.handleCategoryChange.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleConfirm = this.handleConfirm.bind(this);
	}

	handleConfirm()
	{
		if (this.state.replacementCategoryId)
		{
			this.props.onDelete(this.state.replacementCategoryId);
		}
		this.handleClose();
	}

	handleClose()
	{
		this.props.onClose();
	}

	handleCategoryChange(category)
	{
		let categoryId = category ? category.id : null;
		this.setState({replacementCategoryId: categoryId});
	}

	render()
	{
		const replacementCategoryId = this.state.replacementCategoryId;

		const footerElements = [
			<Button key={0} onClick={this.handleConfirm}>Confirm</Button>,
			<Button key={1} onClick={this.handleClose}>Close</Button>
		];

		return (
			<ModalWrapper
				title={"Category Replacement"}
				modalClassName={"budget-audit-modal"}
				footerElements={footerElements}
			>
				<Row>
					<Col xs={12}>
						<p>This category is being used, please select a replacement for records using this category.</p>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<CategorySelect
							onSelect={this.handleCategoryChange}
							value={replacementCategoryId}
							options={this.props.categories}
							autoFocus={true}
						/>
					</Col>
				</Row>
			</ModalWrapper>
		);
	}
}

CategoryDeleteModal.propTypes = {
	onClose: PropTypes.func,
	onDelete: PropTypes.func,
	categoryId: PropTypes.number,
	categories: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string
		})
	)
};



// WEBPACK FOOTER //
// ./Components/components/CategoryDeleteModal.jsx